import ConnectionTypeRadioGroup from '../ConnectionTypeRadioGroup'
import IpAddressField from '../IpAddressField'
import { ConnectionType } from '@/features/print/constants'
import { useConnectionTypeValue } from '@/features/settings/components/AddPrinterModal/form'
import { FC } from 'react'

interface FormFieldsProps {
    availableConnectionTypes: ConnectionType[]
}

const FormFields: FC<FormFieldsProps> = ({ availableConnectionTypes }) => {
    const selectedConnectionType = useConnectionTypeValue()

    return (
        <>
            <ConnectionTypeRadioGroup connectionTypes={availableConnectionTypes} />
            {selectedConnectionType === ConnectionType.Network && <IpAddressField />}
        </>
    )
}

export default FormFields
